import * as $ from "jquery";

export default {

	getFields(Selector) {
		return {
			"cart[delivery_method]": 'required',
			"cart[payment_method]" : 'required',
			"cart[agree_rules]"    : {required: !Selector.IS_LOGGED_IN},
			"cart[agree_data]"     : {required: !Selector.IS_LOGGED_IN},
			"cart[delivery_department_id]" : {
				required : false,
				customDepartmentIdValidate: { DeliveryRadioButton : $('#cart_delivery_method_19') }
			},
			"cart[remarks]": {
				maxlength: 50
			}
		}
	}
}import * as $ from "jquery";

export default {

	getFields(Selector) {
		return {
			"cart[delivery_method]": 'required',
			"cart[payment_method]" : 'required',
			"cart[agree_rules]"    : {required: !Selector.IS_LOGGED_IN},
			"cart[agree_data]"     : {required: !Selector.IS_LOGGED_IN},
			"cart[delivery_department_id]" : {
				required : false,
				customDepartmentIdValidate: { DeliveryRadioButton : $('#cart_delivery_method_19') }
			},
			"cart[remarks]": {
				maxlength: 50
			}
		}
	}
}